import { render } from "./searchPage.vue?vue&type=template&id=21527d93&scoped=true&ts=true"
import script from "./searchPage.vue?vue&type=script&lang=ts"
export * from "./searchPage.vue?vue&type=script&lang=ts"

import "./searchPage.vue?vue&type=style&index=0&id=21527d93&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21527d93"]])

export default __exports__